import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HeaderComponent } from '../../header/header.component';

@Component({
  selector: 'app-onboarding-in-process',
  standalone: true,
  imports: [ MatIconModule, HeaderComponent,
      ],
  templateUrl: './onboarding-in-process.component.html',
  styleUrl: './onboarding-in-process.component.scss'
})
export class OnboardingInProcessComponent {

}
